// @ts-nocheck

import moment from 'moment'

/**
 * Events appear in home/search listings while at least one session date is still upcoming.
 * Sale window (finalSales) is enforced on the event page / checkout, not in listing.
 */
export const isListableEvent = (event) =>
  !!event?.eventItem?.find((item) =>
    item?.dates?.some((date) => moment().isBefore(date))
  )
